import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../DiscountOffer.module.css';
import { Typography } from '../../../components/Typography/typography';
import { 
    HeroSectionCircle1,
    HeroSectionCircle2,
    HeroSectionCircle3,
    HeroSectionCircle4
} from '../../../assets/images/icons';

const HeroSection = ({ onAvailDiscount, loading, discountApplied }) => {
    const { t } = useTranslation();
    
    return (
        <div className={styles.discountHeroSection}>
            <div className={styles.circleContainer}>
                <img src={HeroSectionCircle1} className={styles.heroCircle1} alt="" />
                <img src={HeroSectionCircle2} className={styles.heroCircle2} alt="" />
                <img src={HeroSectionCircle3} className={styles.heroCircle3} alt="" />
                <img src={HeroSectionCircle4} className={styles.heroCircle4} alt="" />
                <img src={HeroSectionCircle4} className={styles.heroCircle5} alt="" />
                <img src={HeroSectionCircle4} className={styles.heroCircle6} alt="" />
            </div>
            <div className={styles.heroContent}>
                {!discountApplied ? (
                    <>
                        <Typography
                            title={t('discount_offer.hero_before_you_go')}
                            fontSize={18}
                            color="white"
                            weight="500"
                            textAlignCenter="center"
                        />
                        <Typography
                            fontSize={32}
                            title={<>{t('discount_offer.stay_with_us')}  <span className={styles.discountHighlight}>{t('discount_offer.discount_percentage')}</span> {t('discount_offer.off_next_month')}</>}
                            color="white"
                            weight="700"
                            textAlignCenter="center"
                        />
                        <div className={styles.discountButtonContainer}>
                            <button 
                                className={styles.discountButton} 
                                onClick={onAvailDiscount}
                                disabled={loading}
                            >
                                <Typography
                                    title={t('discount_offer.avail_discount_button')}
                                    fontSize={16}
                                    weight="600"
                                    color="#0464B2"
                                />
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <Typography
                            title={t('discount_offer.discount_already_applied_title')}
                            fontSize={32}
                             style={{ 
                                marginBottom: '20px',
                                lineHeight: '1.2',
                                 color: 'white',
                                fontWeight: '700',
                                textAlign: 'center',
                                 letterSpacing: '0.5px'
                            }}
                        />
                        <Typography
                            fontSize={24}
                            title={t('discount_offer.discount_already_applied_desc')}
                             style={{ 
                                maxWidth: '800px', 
                                margin: '0 auto',
                                opacity: 0.9,
                                fontSize: '24px',
                                color: 'white',
                                fontWeight: '500',
                                textAlign: 'center',
                                letterSpacing: '0.5px'
                            }}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default HeroSection; 